<template>
  <div>
    <myHeader/>
    <banner title="报告查询"/>
    <div v-if="!reportId" class="report-main">
      <!-- 暂无报告 -->
      <div class="report-zero">
        <el-image class="none-image" :src="noneImage" />
        <div class="none-tip">暂无报告</div>
      </div>
    </div>
    <div v-else class="detail-container">
      <div class="detail-title">养老机构服务信用评价报告</div>
      <div class="detail-no">（编号： {{ reportNo }}）</div>
      <div class="detail-main">
        <div class="detail-content">
          <div class="d-c-title-1">
            <span>1、基本信息</span>
            <span @click="doDownloadReport" class="one-btn">报告下载</span>
          </div>
          <el-descriptions :column="1" border>
            <el-descriptions-item v-for="one in baseData" v-bind:key="one.label" :label="one.label"
                                  label-class-name="desc-label" content-class-name="desc-content">
              <span v-if="one.label == '法人性质'">{{
                  one.content == '1' ? '企业法人' : one.content == '2' ? '民办非企业法人' : '事业单位法人'
                }}</span>
              <span v-else>{{ one.content }}</span>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <div class="detail-content">
          <div class="d-c-title-1">
            <span>2、 跨平台养老机构服务信用评分</span>
          </div>

          <!-- <div class="not-vip">
            <div class="not-vip-tips">成为VIP会员，即可查看企业更多信息</div>
            <div class="not-vip-white">
              <div class="open-vip">立即开通</div>
            </div>
          </div> -->

          <div class="d-c-title-2">跨平台信用评分</div>
          <el-table ref="detail2" :data="crossPlatformData" style="width: 1080px" border :header-cell-style="rowClass">
            <el-table-column property="creditType" label="信用类型">
              <template slot="header"><span class="table-col-name">信用类型</span></template>
            </el-table-column>
            <el-table-column property="creditScore" label="信用分值">
              <template slot="header"><span class="table-col-name">信用分值</span></template>
            </el-table-column>
            <el-table-column property="creditLevel" label="信用评价">
              <template slot="header"><span class="table-col-name">信用评价</span></template>
            </el-table-column>
            <!--            <el-table-column property="creditDesc" label="信用解释">-->
            <!--              <template slot="header"><span class="table-col-name">信用解释</span></template>-->
            <!--            </el-table-column>-->
          </el-table>

          <div class="d-c-title-2">共有指标信用评分</div>
          <div>
            <div class="level-title-row">
              <div class="gyzb-title-1">一级指标</div>
              <div class="gyzb-title-2">二级指标</div>
              <div class="gyzb-title-3">信用评分</div>
            </div>
            <!-- 基础等级类 -->
            <div class="jcdj" v-for="(common, comindex) in commonList" v-bind:key="comindex">
              <div class="common-table-left">{{ common.name.substring(2) }}</div>
              <div class="common-table-middle">
                <div class="common-table-middle-one" v-for="(subcom, scomindex) in common.list" v-bind:key="scomindex">
                  {{
                    subcom.name.substring(4)
                  }}
                </div>
              </div>
              <div class="common-table-right">
                <div class="common-table-right-one" v-for="(subcom, scomindex) in common.list" v-bind:key="scomindex">{{
                    subcom.score
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="d-c-title-2">特有指标信用评分</div>
          <div>
            <div class="level-title-row">
              <div class="gyzb-title-1">一级指标</div>
              <div class="gyzb-title-2">二级指标</div>
              <div class="gyzb-title-3">信用评分</div>
            </div>
            <!-- 行业特质经营能力 -->
            <div class="jcdj" v-for="(specific, spindex) in specificList" v-bind:key="spindex">
              <div class="common-table-left">{{ specific.name.substring(2) }}</div>
              <div class="common-table-middle">
                <div class="common-table-middle-one" v-for="(spsub, spsubindex) in specific.list"
                     v-bind:key="spsubindex">
                  {{ spsub.name.substring(4) }}
                </div>
              </div>
              <div class="common-table-right">
                <div class="common-table-right-one" v-for="(spsub, spsubindex) in specific.list"
                     v-bind:key="spsubindex">
                  {{ spsub.score }}
                </div>
              </div>
            </div>
          </div>

          <div class="d-c-title-2">信用等级划分标准</div>
          <div class="level-title-row common-row">
            <div class="l-t-r-1">信用等级</div>
            <div class="l-t-r-2">评分</div>
            <div class="l-t-r-3">信用状况</div>
          </div>
          <div class="common-row level-content-a" v-for="(level, lindex) in levelList" v-bind:key="lindex">
            <div class="l-c-1">
              <div class="l-c-1-left border-l-and-b">{{ level.levelName }}</div>
              <div class="l-c-1-right">
                <div class="l-c-1-right-one border-l-and-b" v-for="(sub, sindex) in level.list" v-bind:key="sindex">{{
                    sub.levelName
                  }}
                </div>
              </div>
            </div>
            <div class="l-c-2">
              <div class="l-c-2-one border-l-and-b " v-for="(sub, sindex) in level.list" v-bind:key="sindex">{{
                  sub.scoreRange
                }}
              </div>
            </div>
            <div class="l-c-3">
              <div class="l-c-2-one border-r border-l-and-b " v-for="(sub, sindex) in level.list" v-bind:key="sindex">{{
                  sub.remark
                }}
              </div>
            </div>
          </div>


          <div class="d-c-title-2">公共信用评价等级划分表</div>
          <el-table ref="detail2" :data="pubCreditList" style="width: 1080px" border :header-cell-style="rowClass">
            <el-table-column property="levelName" label="公共信用评价等级">
              <template slot="header"><span class="table-col-name">公共信用评价等级</span></template>
            </el-table-column>
            <el-table-column property="levelDesc" label="等级说明">
              <template slot="header"><span class="table-col-name">等级说明</span></template>
            </el-table-column>
            <el-table-column property="scoreRange" label="对应分数区间">
              <template slot="header"><span class="table-col-name">对应分数区间</span></template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <myFooter bgc="black"/>
  </div>
</template>

<script>
import {indexSearch, reportDetail} from "@/api/common";
import Cookies from "js-cookie";

export default {
  name: "reportDetail",
  data() {
    return {
      reportId: null,
      noneImage: require('../../assets/none.png'),
      levelList: [],
      commonList: [],
      specificList: [],
      reportNo: "",
      baseData: [],
      crossPlatformData: [],
      pubCreditList: []
    }
  },
  created() {
    let keywords = this.$route.params.keywords
    if (keywords) {
      indexSearch(keywords).then(res => {
        this.handleData(res.data)
      })
      return
    }
    let paramId = this.$route.params.id
    let id = paramId || Cookies.get("reportDetailId")
    this.init(id);
  },
  methods: {
    init(id) {
      // 报告列表 401 根据参数查询详情
      reportDetail(id).then(res => {
        this.handleData(res.data)
      })
    },
    handleData(res) {
      this.reportId = res.id
      Cookies.set("reportDetailId", res.id)
      // 1 报告编号
      this.reportNo = res.reportNo
      // 2 基础数据
      let base = res.base
      this.baseData = [
        {
          label: "企业名称",
          content: base.companyName
        },
        {
          label: "统一社会信用代码",
          content: base.uscCode
        },
        {
          label: "企业类型",
          content: base.companyType
        },
        {
          label: "法定代表人",
          content: base.juridicalPerson
        },
        {
          label: "法人性质",
          content: base.legalNature
        },
        {
          label: "注册资本",
          content: base.registeredCapital
        },
        {
          label: "经营状态",
          content: base.businessStatus
        },
        {
          label: "注册日期",
          content: base.registrationDate
        },
        {
          label: "登记机关",
          content: base.registrationAuthority
        },
        {
          label: "注册地址",
          content: base.registeredAddress
        }
      ]
      // 4 等级标准
      this.levelList = res.levelList
      // 5 共有指标
      this.commonList = res.commonList
      // 6 特有指标
      this.specificList = res.specificList
      // 7 跨平台
      this.crossPlatformData = res.list
      // 8 公共信用等级划分
      this.pubCreditList = res.pubCreditList
    },

    // 设置表格头部样式 背景色
    rowClass({rowIndex, columnIndex}) {
      if (rowIndex === 0) {
        return {background: '#fafbfc'}
      }
    },
    doDownloadReport() {
      window.location.href = domain.api + '/credit/report/export?id=' + this.reportId
    }
  }

}
</script>

<style scoped>
.report-main {
  width: 100%;
  min-height: 458px;
  padding-bottom: 38px;
}

.report-zero {
  display: flex;
  flex-direction: column;
  justify-content: center;

}

.none-image {
  width: 160px;
  height: 160px;
  margin: 57px auto 10px;
}

.none-tip {
  text-align: center;
}

/deep/ .el-table__empty-text {
  font-size: 14px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

/deep/ .el-table .cell {
  color: black !important;
  /*padding-top: 3px;*/
  /*padding-left: 13px;*/
}

/deep/ .desc-label {
  width: 270px;
  height: 48px;
  padding-top: 15px !important;
  padding-left: 23px !important;
  background: rgba(250, 251, 252, 1) !important;
  color: rgba(51, 51, 51, 1) !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

/deep/ .desc-content {
  font-size: 14px;
  font-weight: 400;
  height: 48px;
  padding-top: 14px !important;
  padding-left: 24px !important;
  color: rgba(51, 51, 51, 1) !important;
}

.detail-common-title {
  margin-top: 14px;
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 700;
}

.detail-main-3 {
  font-size: 16px;
  font-weight: 700;
  color: rgba(51, 51, 51, 1);
  margin-top: 16px;
  margin-bottom: -2px;
}

.one-btn {
  letter-spacing: 0px;
  line-height: 24px;
  text-decoration-line: underline;
  color: rgba(63, 140, 255, 1) !important;
  margin-right: 24px;
  cursor: pointer;
}

.detail-main-1 {
  font-size: 16px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 20px;
}

/* 以上是旧的样式 */

/* A 评级这一行 s */
.level-content-a {
  background-color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.level-content-b {
  height: 160px !important;
  background-color: #fff;
  font-size: 14px;
  font-weight: 400;
}

.b-height {
  height: 160px !important;
}

.l-c-1 {
  width: 146px;
  display: flex;
}

.l-c-1-left {
  width: 59px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.l-c-1-right {
  width: 86px;
  display: flex;
  flex-direction: column;
}

.l-c-1-right-one {
  height: 40px;
  width: 66px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.d-height {
  height: 160px;
}

.merge2row {
  height: 80px !important;
}

.l-c-2 {
  width: 394px;
}

.l-c-3 {
  width: 540px;
}

.l-c-2-one {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.border-r {
  border-right: 1px solid rgba(216, 224, 240, 1);
}

/* A 评级这一行 e */
.border-l-and-b {
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
}

/* 信用评级标准 标题 s */
.l-t-r-3 {
  width: 520px;
  height: 38px;
  padding-left: 20px;
  border: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.l-t-r-2 {
  width: 373px;
  height: 38px;
  padding-left: 20px;
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-top: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.l-t-r-1 {
  width: 125px;
  height: 38px;
  padding-left: 20px;
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-top: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.w-273 {
  width: 273px !important;
}

.w-539 {
  width: 539px !important;
}

.w-268 {
  width: 268px !important;
}

.level-title-row {
  width: 1080px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  background: rgba(250, 251, 252, 1);
}

.common-row {
  width: 1080px;
  min-height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center
}

.jcdj {
  min-height: 40px;
  background-color: #fff;
  width: 1080px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
}

.one-option-1 {
  width: 273px;
}

.one-option-2 {
  width: 539px;
}

.one-option-3 {
  width: 268px;
}

.gyzb-title-1 {
  width: 263px;
  height: 38px;
  padding-left: 20px;
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-top: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.common-table-left {
  width: 253px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.h-280 {
  height: 280px !important;
}

.h-440 {
  height: 440px !important;
}

.h-240 {
  height: 240px !important;
}

.h-160 {
  height: 160px !important;
}

.h-120 {
  height: 120px !important;
}

.h-80 {
  height: 80px !important;
}

.h-40 {
  height: 40px !important;
}

.no-top-border {
  border-top: none !important;
}

.gyzb-title-2 {
  width: 539px;
  height: 38px;
  padding-left: 20px;
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-top: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.common-table-middle {
  width: 539px;
  /* height: 200px; */
  display: flex;
  flex-direction: column;
}


.common-table-middle-one {
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.common-table-middle-one:last-child {
  border-bottom: none;
}

.common-table-right-one {
  border-left: 1px solid rgba(216, 224, 240, 1);
  border-bottom: 1px solid rgba(216, 224, 240, 1);
  border-right: 1px solid rgba(216, 224, 240, 1);
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}

.common-table-right-one:last-child {
  border-bottom: none;
}

.gyzb-title-3 {
  width: 257px;
  height: 38px;
  padding-left: 20px;
  border: 1px solid rgba(216, 224, 240, 1);
  display: flex;
  align-items: center;
}

.common-table-right {
  width: 268px;
  display: flex;
  flex-direction: column;
}

/* 信用评级标准 标题 e */
.d-c-title-2 {
  font-size: 14px;
  font-weight: 700;
  margin: 24px auto 16px;
  text-align: center;
}

.d-c-title-1 {
  font-size: 16px;
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 16px;
}

.not-vip {
  width: 1080px;
  height: 840px;
  background: rgba(204, 230, 255, 1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.not-vip-tips {
  margin-top: 64px;
  margin-bottom: 38px;
  /** 文本1 */
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: rgba(51, 51, 51, 1);
}

.not-vip-white {
  width: 1012px;
  height: 675px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.open-vip {
  margin-top: 467px;
  width: 132px;
  height: 48px;
  border-radius: 4px;
  background: rgba(63, 140, 255, 1);
  /** 文本1 */
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.detail-content {
  width: 1080px;
  min-height: 100px;
  margin: 0 auto 24px;
}

.detail-main {
  width: 1080px;
  min-height: 813px;
  margin: 0 auto;
}

.detail-no {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 33px;
}

.detail-title {
  font-size: 24px;
  font-weight: 700;
  padding-top: 36px;
  padding-bottom: 10px;
  text-align: center;
}

.detail-container {
  /* overflow: auto; */
  width: 1140px;
  min-height: 700px;
  border-radius: 8px;
  background: rgba(243, 248, 253, 1);
  color: rgba(51, 51, 51, 1);
  margin: 10px auto;
  padding-bottom: 10px;
}


/* 设置滚动条显示隐藏 */
::-webkit-scrollbar {
  width: 0px !important;
}

/* 设置滚动条的样式 */
::-webkit-scrollbar {
  width: 5px;
  border-radius: 8px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5); */
  background-color: #fff;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(63, 140, 255, 0.8);
  /* -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5); */
}</style>



// WEBPACK FOOTER //
// src/views/report/detail.vue